import {
  MAX_BRANCH_LEVEL,
  CELERITY,
  SUSTENANCE,
  MIGHT,
  FORTITUDE,
  SORCERY
} from '../../constants';

// For documentation
export const ALL_BREAKPOINTS_AND_SKILLS = [
  // ------------------ CELERITY breakpoints ------------------
  { branch: CELERITY, level:  2, reason: "ACC +5, DODGE +5"  },
  { branch: CELERITY, level:  5, reason: "Skill Up"          },
  { branch: CELERITY, level: 10, reason: "Skill Up"          },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5"  },
  { branch: CELERITY, level: 15, reason: "Skill Up"          },
  { branch: CELERITY, level: 20, reason: "Skill Up"          },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5"  },
  { branch: CELERITY, level: 25, reason: "Skill Up"          },
  { branch: CELERITY, level: 30, reason: "Skill Up"          },
  { branch: CELERITY, level: 35, reason: "Skill Up"          },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7"  },
  { branch: CELERITY, level: 40, reason: "Skill Up"          },
  { branch: CELERITY, level: 45, reason: "Skill Up"          },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8"  },
  { branch: CELERITY, level: 50, reason: "Skill Up"          },
  { branch: CELERITY, level: 52, reason: "ACC +5"            },
  { branch: CELERITY, level: 55, reason: "Skill Up"          },
  { branch: CELERITY, level: 60, reason: "Skill Up"          },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 65, reason: "Skill Up"          },
  { branch: CELERITY, level: 70, reason: "Skill Up"          },
  { branch: CELERITY, level: 75, reason: "Skill Up"          },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 80, reason: "Skill Up"          },
  { branch: CELERITY, level: 82, reason: "ACC +5"            },
  { branch: CELERITY, level: 85, reason: "Skill Up"          },
  // ---------------- end CELERITY breakpoints ----------------

  // ------------------ FORTITUDE breakpoints -----------------
  { branch: FORTITUDE, level:  2, reason: "ACC +10"           },
  { branch: FORTITUDE, level:  5, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 10, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 12, reason: "ACC +10"           },
  { branch: FORTITUDE, level: 15, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 20, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 22, reason: "ACC +10"           },
  { branch: FORTITUDE, level: 25, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 30, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 32, reason: "MSPD +2"           },
  { branch: FORTITUDE, level: 35, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3"   },
  { branch: FORTITUDE, level: 40, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 45, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3"   },
  { branch: FORTITUDE, level: 50, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 52, reason: "ACC +5"            },
  { branch: FORTITUDE, level: 55, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 57, reason: "ACC +5"            },
  { branch: FORTITUDE, level: 60, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3"   },
  { branch: FORTITUDE, level: 65, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 70, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 72, reason: "ACC +5"            },
  { branch: FORTITUDE, level: 75, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3"   },
  { branch: FORTITUDE, level: 80, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 82, reason: "ACC +5"            },
  { branch: FORTITUDE, level: 85, reason: "Skill Up"          },
  { branch: FORTITUDE, level: 87, reason: "ACC +5"            },
  // ---------------- end FORTITUDE breakpoints ----------------

  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level:  2, reason: "ACC +10"           },
  { branch: MIGHT, level:  5, reason: "Skill Up"          },
  { branch: MIGHT, level: 10, reason: "Skill Up"          },
  { branch: MIGHT, level: 12, reason: "ACC +5"            },
  { branch: MIGHT, level: 15, reason: "Skill Up"          },
  { branch: MIGHT, level: 17, reason: "ACC +5"            },
  { branch: MIGHT, level: 20, reason: "Skill Up"          },
  { branch: MIGHT, level: 22, reason: "ACC +5"            },
  { branch: MIGHT, level: 25, reason: "Skill Up"          },
  { branch: MIGHT, level: 27, reason: "ACC +5"            },
  { branch: MIGHT, level: 30, reason: "Skill Up"          },
  { branch: MIGHT, level: 32, reason: "ACC +5"            },
  { branch: MIGHT, level: 35, reason: "Skill Up"          },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2"     },
  { branch: MIGHT, level: 40, reason: "Skill Up"          },
  { branch: MIGHT, level: 45, reason: "Skill Up"          },
  { branch: MIGHT, level: 47, reason: "LL +2"             },
  { branch: MIGHT, level: 50, reason: "Skill Up"          },
  { branch: MIGHT, level: 55, reason: "Skill Up"          },
  { branch: MIGHT, level: 57, reason: "ACC +10"           },
  { branch: MIGHT, level: 60, reason: "Skill Up"          },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1"    },
  { branch: MIGHT, level: 65, reason: "Skill Up"          },
  { branch: MIGHT, level: 70, reason: "Skill Up"          },
  { branch: MIGHT, level: 75, reason: "Skill Up"          },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1"    },
  { branch: MIGHT, level: 80, reason: "Skill Up"          },
  { branch: MIGHT, level: 82, reason: "ACC +5"            },
  { branch: MIGHT, level: 85, reason: "Skill Up"          },
  // ---------------- end MIGHT breakpoints ----------------

  // ----------------- SORCERY breakpoints -----------------
  { branch: SORCERY, level:  2, reason: "CRIT +1"           },
  { branch: SORCERY, level:  5, reason: "Skill Up"          },
  { branch: SORCERY, level: 10, reason: "Skill Up"          },
  { branch: SORCERY, level: 12, reason: "CRIT +1"           },
  { branch: SORCERY, level: 15, reason: "Skill Up"          },
  { branch: SORCERY, level: 17, reason: "DODGE +5"          },
  { branch: SORCERY, level: 20, reason: "Skill Up"          },
  { branch: SORCERY, level: 22, reason: "CRIT +1"           },
  { branch: SORCERY, level: 25, reason: "Skill Up"          },
  { branch: SORCERY, level: 27, reason: "DODGE +5"          },
  { branch: SORCERY, level: 30, reason: "Skill Up"          },
  { branch: SORCERY, level: 35, reason: "Skill Up"          },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 40, reason: "Skill Up"          },
  { branch: SORCERY, level: 45, reason: "Skill Up"          },
  { branch: SORCERY, level: 47, reason: "CRIT +2"           },
  { branch: SORCERY, level: 50, reason: "Skill Up"          },
  { branch: SORCERY, level: 52, reason: "DODGE +5"          },
  { branch: SORCERY, level: 55, reason: "Skill Up"          },
  { branch: SORCERY, level: 60, reason: "Skill Up"          },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 65, reason: "Skill Up"          },
  { branch: SORCERY, level: 70, reason: "Skill Up"          },
  { branch: SORCERY, level: 72, reason: "CRIT +1"           },
  { branch: SORCERY, level: 75, reason: "Skill Up"          },
  { branch: SORCERY, level: 77, reason: "DODGE +10"         },
  { branch: SORCERY, level: 80, reason: "Skill Up"          },
  { branch: SORCERY, level: 82, reason: "DODGE +5"          },
  { branch: SORCERY, level: 85, reason: "Skill Up"          },
  // ---------------- end SORCERY breakpoints ----------------

  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level:  2, reason: "MSPD +3"           },
  { branch: SUSTENANCE, level:  5, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3"           },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3"           },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5"          },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3"           },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5"          },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up"          },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5"          },
  // ---------------- end SUSTENANCE breakpoints ----------------
];

// For maxing out skills after
const MAX_OUT = [];
const branches = [SUSTENANCE, CELERITY, FORTITUDE, MIGHT, SORCERY];
branches.forEach(branch => {
  for(let level = 1; level <= MAX_BRANCH_LEVEL; level++){
    MAX_OUT.push({ branch, level, reason: "Using leftovers" });
  }
})

// PVP META
export const SKYE_BUILD = [
  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: 'MSPD +3' },
  { branch: SUSTENANCE, level: 5, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 10, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 12, reason: 'MSPD +3' },
  { branch: SUSTENANCE, level: 15, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 20, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 22, reason: 'MSPD +3' },
  { branch: SUSTENANCE, level: 25, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 30, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 35, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 37, reason: 'MSPD +3, DODGE +5' },
  { branch: SUSTENANCE, level: 40, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 45, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 47, reason: 'MSPD +3, DODGE +5' },
  { branch: SUSTENANCE, level: 50, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 52, reason: 'DODGE +5' },
  { branch: SUSTENANCE, level: 55, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 60, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 62, reason: 'MSPD +3' },
  { branch: SUSTENANCE, level: 65, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 67, reason: 'DODGE +5' },
  { branch: SUSTENANCE, level: 70, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 75, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 77, reason: 'MSPD +2, DODGE +5' },
  { branch: SUSTENANCE, level: 80, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 85, reason: 'Skill Up' },
  { branch: SUSTENANCE, level: 87, reason: 'DODGE +5' },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------
  { branch: CELERITY, level: 2, reason: 'ACC +5, DODGE +5' },
  { branch: CELERITY, level: 5, reason: 'Skill Up' },
  { branch: CELERITY, level: 10, reason: 'Skill Up' },
  { branch: CELERITY, level: 12, reason: 'ACC +5, DODGE +5' },
  { branch: CELERITY, level: 15, reason: 'Skill Up' },
  { branch: CELERITY, level: 20, reason: 'Skill Up' },
  { branch: CELERITY, level: 22, reason: 'ACC +5, DODGE +5' },
  { branch: CELERITY, level: 25, reason: 'Skill Up' },
  { branch: CELERITY, level: 30, reason: 'Skill Up' },
  { branch: CELERITY, level: 35, reason: 'Skill Up' },
  { branch: CELERITY, level: 37, reason: 'ACC +7, DODGE +7' },
  { branch: CELERITY, level: 40, reason: 'Skill Up' },
  { branch: CELERITY, level: 45, reason: 'Skill Up' },
  { branch: CELERITY, level: 47, reason: 'ACC +8, DODGE +8' },
  { branch: CELERITY, level: 50, reason: 'Skill Up' },
  { branch: CELERITY, level: 52, reason: 'ACC +5' },
  { branch: CELERITY, level: 55, reason: 'Skill Up' },
  { branch: CELERITY, level: 60, reason: 'Skill Up' },
  { branch: CELERITY, level: 62, reason: 'ACC +5, DODGE +10' },
  { branch: CELERITY, level: 65, reason: 'Skill Up' },
  { branch: CELERITY, level: 70, reason: 'Skill Up' },
  { branch: CELERITY, level: 75, reason: 'Skill Up' },
  { branch: CELERITY, level: 77, reason: 'ACC +5, DODGE +10' },
  { branch: CELERITY, level: 80, reason: 'Skill Up' },
  { branch: CELERITY, level: 82, reason: 'ACC +5' },
  { branch: CELERITY, level: 85, reason: 'Skill Up' },
  // ---------------- end CELERITY breakpoints ----------------



  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 30, reason: "Skill Up" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 35, reason: "Skill Up" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 40, reason: "Skill Up" },
  { branch: MIGHT, level: 45, reason: "Skill Up" },
  { branch: MIGHT, level: 47, reason: "LL +2" },

  // ------------------ FORTITUDE breakpoints -----------------
  { branch: FORTITUDE, level: 2, reason: 'ACC +10' },
  { branch: FORTITUDE, level: 5, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 10, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 12, reason: 'ACC +10' },
  { branch: FORTITUDE, level: 15, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 20, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 22, reason: 'ACC +10' },
  { branch: FORTITUDE, level: 25, reason: 'Skill Up' },

  { branch: MIGHT, level: 50, reason: "Skill Up" },
  { branch: MIGHT, level: 55, reason: "Skill Up" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 60, reason: "Skill Up" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 65, reason: "Skill Up" },
  { branch: MIGHT, level: 70, reason: "Skill Up" },
  { branch: MIGHT, level: 75, reason: "Skill Up" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 80, reason: "Skill Up" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 85, reason: "Skill Up" },


  { branch: FORTITUDE, level: 30, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 32, reason: 'MSPD +2' },
  { branch: FORTITUDE, level: 35, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 37, reason: 'ACC +5, MSPD +3' },
  { branch: FORTITUDE, level: 40, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 45, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 47, reason: 'ACC +5, MSPD +3' },
  { branch: FORTITUDE, level: 50, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 52, reason: 'ACC +5' },
  { branch: FORTITUDE, level: 55, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 57, reason: 'ACC +5' },
  { branch: FORTITUDE, level: 60, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 62, reason: 'ACC +5, MSPD +3' },
  { branch: FORTITUDE, level: 65, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 70, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 72, reason: 'ACC +5' },
  { branch: FORTITUDE, level: 75, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 77, reason: 'ACC +5, MSPD +3' },
  { branch: FORTITUDE, level: 80, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 82, reason: 'ACC +5' },
  { branch: FORTITUDE, level: 85, reason: 'Skill Up' },
  { branch: FORTITUDE, level: 87, reason: 'ACC +5' },
  // --------------- END FINISH MAX STUFF OUT ----------------
  ...MAX_OUT,
];

export const FOCUS_META_WITH_SKILLS = [
  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 30, reason: "Skill Up" },
  { branch: CELERITY, level: 35, reason: "Skill Up" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: CELERITY, level: 40, reason: "Skill Up" },
  { branch: CELERITY, level: 45, reason: "Skill Up" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: CELERITY, level: 50, reason: "Skill Up" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: CELERITY, level: 55, reason: "Skill Up" },
  { branch: CELERITY, level: 60, reason: "Skill Up" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 65, reason: "Skill Up" },
  { branch: CELERITY, level: 70, reason: "Skill Up" },
  { branch: CELERITY, level: 75, reason: "Skill Up" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 80, reason: "Skill Up" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  { branch: CELERITY, level: 85, reason: "Skill Up" },
  // ---------------- end CELERITY breakpoints ----------------

  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 30, reason: "Skill Up" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 35, reason: "Skill Up" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 40, reason: "Skill Up" },
  { branch: MIGHT, level: 45, reason: "Skill Up" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 50, reason: "Skill Up" },
  { branch: MIGHT, level: 55, reason: "Skill Up" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 60, reason: "Skill Up" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 65, reason: "Skill Up" },
  { branch: MIGHT, level: 70, reason: "Skill Up" },
  { branch: MIGHT, level: 75, reason: "Skill Up" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 80, reason: "Skill Up" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 85, reason: "Skill Up" },
  // ---------------- end MIGHT breakpoints ----------------

    // ------------------ FORTITUDE breakpoints -----------------
    { branch: FORTITUDE, level: 2, reason: "ACC +10" },
    { branch: FORTITUDE, level: 5, reason: "Skill Up" },
    { branch: FORTITUDE, level: 10, reason: "Skill Up" },
    { branch: FORTITUDE, level: 12, reason: "ACC +10" },
    { branch: FORTITUDE, level: 15, reason: "Skill Up" },
    { branch: FORTITUDE, level: 20, reason: "Skill Up" },
    { branch: FORTITUDE, level: 22, reason: "ACC +10" },
    { branch: FORTITUDE, level: 25, reason: "Skill Up" },
    { branch: FORTITUDE, level: 30, reason: "Skill Up" },
    { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
    { branch: FORTITUDE, level: 35, reason: "Skill Up" },
    { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
    { branch: FORTITUDE, level: 40, reason: "Skill Up" },
    { branch: FORTITUDE, level: 45, reason: "Skill Up" },
    { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
    { branch: FORTITUDE, level: 50, reason: "Skill Up" },
    { branch: FORTITUDE, level: 52, reason: "ACC +5" },
    { branch: FORTITUDE, level: 55, reason: "Skill Up" },
    { branch: FORTITUDE, level: 57, reason: "ACC +5" },
    { branch: FORTITUDE, level: 60, reason: "Skill Up" },
    { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
    { branch: FORTITUDE, level: 65, reason: "Skill Up" },
    { branch: FORTITUDE, level: 70, reason: "Skill Up" },
    { branch: FORTITUDE, level: 72, reason: "ACC +5" },
    { branch: FORTITUDE, level: 75, reason: "Skill Up" },
    { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
    { branch: FORTITUDE, level: 80, reason: "Skill Up" },
    { branch: FORTITUDE, level: 82, reason: "ACC +5" },
    { branch: FORTITUDE, level: 85, reason: "Skill Up" },
    { branch: FORTITUDE, level: 87, reason: "ACC +5" },
    // ---------------- end FORTITUDE breakpoints ----------------

  // ----------------- SORCERY breakpoints -----------------
  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 30, reason: "Skill Up" },
  { branch: SORCERY, level: 35, reason: "Skill Up" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 40, reason: "Skill Up" },
  { branch: SORCERY, level: 45, reason: "Skill Up" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 50, reason: "Skill Up" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 55, reason: "Skill Up" },
  { branch: SORCERY, level: 60, reason: "Skill Up" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 65, reason: "Skill Up" },
  { branch: SORCERY, level: 70, reason: "Skill Up" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 75, reason: "Skill Up" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 80, reason: "Skill Up" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: SORCERY, level: 85, reason: "Skill Up" },
  // ---------------- end SORCERY breakpoints ----------------
  ...MAX_OUT,
];

export const FOCUS_META_WITHOUT_SKILLS = [
  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  // ---------------- end CELERITY breakpoints ----------------

  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  // ---------------- end MIGHT breakpoints ----------------

   // ------------------ FORTITUDE breakpoints -----------------
   { branch: FORTITUDE, level: 2, reason: "ACC +10" },
   { branch: FORTITUDE, level: 12, reason: "ACC +10" },
   { branch: FORTITUDE, level: 22, reason: "ACC +10" },
   { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
   { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 52, reason: "ACC +5" },
   { branch: FORTITUDE, level: 57, reason: "ACC +5" },
   { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 72, reason: "ACC +5" },
   { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 82, reason: "ACC +5" },
   { branch: FORTITUDE, level: 87, reason: "ACC +5" },
   // ---------------- end FORTITUDE breakpoints ----------------

  // ----------------- SORCERY breakpoints -----------------
  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  // ---------------- end SORCERY breakpoints ----------------
  ...MAX_OUT,
];

// MORE ROUNDED PVP META
export const FOCUS_SKILLS_FIRST = [
  // ----------------- <=25 breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },

  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },



  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },

  { branch: FORTITUDE, level: 2, reason: "ACC +10" },
  { branch: FORTITUDE, level: 5, reason: "Skill Up" },
  { branch: FORTITUDE, level: 10, reason: "Skill Up" },
  { branch: FORTITUDE, level: 12, reason: "ACC +10" },
  { branch: FORTITUDE, level: 15, reason: "Skill Up" },
  { branch: FORTITUDE, level: 20, reason: "Skill Up" },
  { branch: FORTITUDE, level: 22, reason: "ACC +10" },
  { branch: FORTITUDE, level: 25, reason: "Skill Up" },

  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  // ---------------- end <=25 breakpoints ----------------



  // ---------------- SUSTENANCE breakpoints ----------------
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------
 
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  // ---------------- end CELERITY breakpoints ----------------

 

  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  // ---------------- end MIGHT breakpoints ----------------


   // ------------------ FORTITUDE breakpoints -----------------
  
   { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
   { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 52, reason: "ACC +5" },
   { branch: FORTITUDE, level: 57, reason: "ACC +5" },
   { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 72, reason: "ACC +5" },
   { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 82, reason: "ACC +5" },
   { branch: FORTITUDE, level: 87, reason: "ACC +5" },
   // ---------------- end FORTITUDE breakpoints ----------------

  // ----------------- SORCERY breakpoints -----------------
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  // ---------------- end SORCERY breakpoints ----------------
  ...MAX_OUT,
];

export const ROUNDED_SKILLS_FOCUS_AFTER = [
  // ----------------- <=25 breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: FORTITUDE, level: 2, reason: "ACC +10" },
  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: FORTITUDE, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: FORTITUDE, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: FORTITUDE, level: 12, reason: "ACC +10" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: FORTITUDE, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },

  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: FORTITUDE, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: FORTITUDE, level: 22, reason: "ACC +10" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: FORTITUDE, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  // ---------------- end <=25 breakpoints ----------------



  // ---------------- SUSTENANCE breakpoints ----------------
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------

  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  // ---------------- end CELERITY breakpoints ----------------

 

  // ----------------- MIGHT breakpoints -----------------
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  // ---------------- end MIGHT breakpoints ----------------

   // ------------------ FORTITUDE breakpoints -----------------

   { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
   { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 52, reason: "ACC +5" },
   { branch: FORTITUDE, level: 57, reason: "ACC +5" },
   { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 72, reason: "ACC +5" },
   { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
   { branch: FORTITUDE, level: 82, reason: "ACC +5" },
   { branch: FORTITUDE, level: 87, reason: "ACC +5" },
   // ---------------- end FORTITUDE breakpoints ----------------

  // ----------------- SORCERY breakpoints -----------------
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  // ---------------- end SORCERY breakpoints ----------------
  ...MAX_OUT,
];

export const FOCUS_ONE_FIRST_ROUNDED_AFTER = [

  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: FORTITUDE, level: 2, reason: "ACC +10" },
  { branch: SORCERY, level: 2, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: FORTITUDE, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: FORTITUDE, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: FORTITUDE, level: 12, reason: "ACC +10" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: FORTITUDE, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },

  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: FORTITUDE, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: FORTITUDE, level: 22, reason: "ACC +10" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: FORTITUDE, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },

  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },

  { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },

  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },

  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: FORTITUDE, level: 52, reason: "ACC +5" },

  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: FORTITUDE, level: 57, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },

  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },

  { branch: FORTITUDE, level: 72, reason: "ACC +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },

  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  { branch: FORTITUDE, level: 82, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  { branch: FORTITUDE, level: 87, reason: "ACC +5" },
  ...MAX_OUT,
];

export const FOCUS_TWO_FIRST_ROUNDED_AFTER = [

  // ----------------- SUSTENANCE breakpoints -----------------
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ---------------- end SUSTENANCE breakpoints ----------------

  // ------------------ CELERITY breakpoints ------------------
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 30, reason: "Skill Up" },
  { branch: CELERITY, level: 35, reason: "Skill Up" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: CELERITY, level: 40, reason: "Skill Up" },
  { branch: CELERITY, level: 45, reason: "Skill Up" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: CELERITY, level: 50, reason: "Skill Up" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: CELERITY, level: 55, reason: "Skill Up" },
  { branch: CELERITY, level: 60, reason: "Skill Up" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 65, reason: "Skill Up" },
  { branch: CELERITY, level: 70, reason: "Skill Up" },
  { branch: CELERITY, level: 75, reason: "Skill Up" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: CELERITY, level: 80, reason: "Skill Up" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  { branch: CELERITY, level: 85, reason: "Skill Up" },
  // ---------------- end CELERITY breakpoints ----------------

  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: SORCERY, level: 2, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: FORTITUDE, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: FORTITUDE, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 12, reason: "ACC +10" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: FORTITUDE, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },

  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: FORTITUDE, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 22, reason: "ACC +10" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: FORTITUDE, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },

  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },

  { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },

  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },

  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: FORTITUDE, level: 52, reason: "ACC +5" },

  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: FORTITUDE, level: 57, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },

  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },

  { branch: FORTITUDE, level: 72, reason: "ACC +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },

  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  { branch: FORTITUDE, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  { branch: FORTITUDE, level: 87, reason: "ACC +5" },
  ...MAX_OUT,
];

export const WELL_ROUNDED = [
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: CELERITY, level: 2, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: SORCERY, level: 2, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: CELERITY, level: 5, reason: "Skill Up" },
  { branch: FORTITUDE, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: CELERITY, level: 10, reason: "Skill Up" },
  { branch: FORTITUDE, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: CELERITY, level: 12, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 12, reason: "ACC +10" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: CELERITY, level: 15, reason: "Skill Up" },
  { branch: FORTITUDE, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },

  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: CELERITY, level: 20, reason: "Skill Up" },
  { branch: FORTITUDE, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: CELERITY, level: 22, reason: "ACC +5, DODGE +5" },
  { branch: FORTITUDE, level: 22, reason: "ACC +10" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },

  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: CELERITY, level: 25, reason: "Skill Up" },
  { branch: FORTITUDE, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  
  { branch: FORTITUDE, level: 32, reason: "MSPD +2" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 37, reason: "ACC +7, DODGE +7" },
  { branch: FORTITUDE, level: 37, reason: "ACC +5, MSPD +3" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: CELERITY, level: 47, reason: "ACC +8, DODGE +8" },
  { branch: FORTITUDE, level: 47, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },

  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: CELERITY, level: 52, reason: "ACC +5" },
  { branch: FORTITUDE, level: 52, reason: "ACC +5" },
  
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: FORTITUDE, level: 57, reason: "ACC +5" },

  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: CELERITY, level: 62, reason: "ACC +5, DODGE +10" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: FORTITUDE, level: 62, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },

  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  
  { branch: FORTITUDE, level: 72, reason: "ACC +5" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: CELERITY, level: 77, reason: "ACC +5, DODGE +10" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: FORTITUDE, level: 77, reason: "ACC +5, MSPD +3" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: CELERITY, level: 82, reason: "ACC +5" },
  { branch: FORTITUDE, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  { branch: FORTITUDE, level: 87, reason: "ACC +5" },
  // ...MAX_OUT,
];


// PVE BUILDS
export const TALENE_ROSA_TWINS_ROWAN_EZIZH = [
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ...MAX_OUT,
];

export const TALENE_ROWAN_EZIZH_MEHIRA_TWINS = [
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },

  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 30, reason: "Skill Up" },
  { branch: SORCERY, level: 35, reason: "Skill Up" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 40, reason: "Skill Up" },
  { branch: SORCERY, level: 45, reason: "Skill Up" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 50, reason: "Skill Up" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 55, reason: "Skill Up" },
  { branch: SORCERY, level: 60, reason: "Skill Up" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 65, reason: "Skill Up" },
  { branch: SORCERY, level: 70, reason: "Skill Up" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 75, reason: "Skill Up" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 80, reason: "Skill Up" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: SORCERY, level: 85, reason: "Skill Up" },
  // ...MAX_OUT,
];

export const TALENE_ROSA_WAREK_ROWAN_TWINS = [
  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },

  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },
  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 30, reason: "Skill Up" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 35, reason: "Skill Up" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 40, reason: "Skill Up" },
  { branch: MIGHT, level: 45, reason: "Skill Up" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 50, reason: "Skill Up" },
  { branch: MIGHT, level: 55, reason: "Skill Up" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 60, reason: "Skill Up" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 65, reason: "Skill Up" },
  { branch: MIGHT, level: 70, reason: "Skill Up" },
  { branch: MIGHT, level: 75, reason: "Skill Up" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 80, reason: "Skill Up" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 85, reason: "Skill Up" },
  // ...MAX_OUT,
];

export const SHEMIRA_ROWAN_BADEN_ROSA_TWINS = [

  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 30, reason: "Skill Up" },
  { branch: SORCERY, level: 35, reason: "Skill Up" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 40, reason: "Skill Up" },
  { branch: SORCERY, level: 45, reason: "Skill Up" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 50, reason: "Skill Up" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 55, reason: "Skill Up" },
  { branch: SORCERY, level: 60, reason: "Skill Up" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 65, reason: "Skill Up" },
  { branch: SORCERY, level: 70, reason: "Skill Up" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 75, reason: "Skill Up" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 80, reason: "Skill Up" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: SORCERY, level: 85, reason: "Skill Up" },


  { branch: MIGHT, level: 2, reason: "ACC +10" },
  { branch: MIGHT, level: 5, reason: "Skill Up" },
  { branch: MIGHT, level: 10, reason: "Skill Up" },
  { branch: MIGHT, level: 12, reason: "ACC +5" },
  { branch: MIGHT, level: 15, reason: "Skill Up" },
  { branch: MIGHT, level: 17, reason: "ACC +5" },
  { branch: MIGHT, level: 20, reason: "Skill Up" },
  { branch: MIGHT, level: 22, reason: "ACC +5" },
  { branch: MIGHT, level: 25, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },

  { branch: MIGHT, level: 27, reason: "ACC +5" },
  { branch: MIGHT, level: 30, reason: "Skill Up" },
  { branch: MIGHT, level: 32, reason: "ACC +5" },
  { branch: MIGHT, level: 35, reason: "Skill Up" },
  { branch: MIGHT, level: 37, reason: "ACC +5, LL +2" },
  { branch: MIGHT, level: 40, reason: "Skill Up" },
  { branch: MIGHT, level: 45, reason: "Skill Up" },
  { branch: MIGHT, level: 47, reason: "LL +2" },
  { branch: MIGHT, level: 50, reason: "Skill Up" },
  { branch: MIGHT, level: 55, reason: "Skill Up" },
  { branch: MIGHT, level: 57, reason: "ACC +10" },
  { branch: MIGHT, level: 60, reason: "Skill Up" },
  { branch: MIGHT, level: 62, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 65, reason: "Skill Up" },
  { branch: MIGHT, level: 70, reason: "Skill Up" },
  { branch: MIGHT, level: 75, reason: "Skill Up" },
  { branch: MIGHT, level: 77, reason: "ACC +10, LL +1" },
  { branch: MIGHT, level: 80, reason: "Skill Up" },
  { branch: MIGHT, level: 82, reason: "ACC +5" },
  { branch: MIGHT, level: 85, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ...MAX_OUT,
];

export const SHEMIRA_ESTRILDA_ROSA_ROWAN_TWINS = SHEMIRA_ROWAN_BADEN_ROSA_TWINS.slice();

export const BELINDA_ROSA_TWINS_ROWAN_LORSAN = [

  { branch: SORCERY, level: 2, reason: "CRIT +1" },
  { branch: SORCERY, level: 5, reason: "Skill Up" },
  { branch: SORCERY, level: 10, reason: "Skill Up" },
  { branch: SORCERY, level: 12, reason: "CRIT +1" },
  { branch: SORCERY, level: 15, reason: "Skill Up" },
  { branch: SORCERY, level: 17, reason: "DODGE +5" },
  { branch: SORCERY, level: 20, reason: "Skill Up" },
  { branch: SORCERY, level: 22, reason: "CRIT +1" },
  { branch: SORCERY, level: 25, reason: "Skill Up" },
  { branch: SORCERY, level: 27, reason: "DODGE +5" },
  { branch: SORCERY, level: 30, reason: "Skill Up" },
  { branch: SORCERY, level: 35, reason: "Skill Up" },
  { branch: SORCERY, level: 37, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 40, reason: "Skill Up" },
  { branch: SORCERY, level: 45, reason: "Skill Up" },
  { branch: SORCERY, level: 47, reason: "CRIT +2" },
  { branch: SORCERY, level: 50, reason: "Skill Up" },
  { branch: SORCERY, level: 52, reason: "DODGE +5" },
  { branch: SORCERY, level: 55, reason: "Skill Up" },
  { branch: SORCERY, level: 60, reason: "Skill Up" },
  { branch: SORCERY, level: 62, reason: "CRIT +1, DODGE +5" },
  { branch: SORCERY, level: 65, reason: "Skill Up" },
  { branch: SORCERY, level: 70, reason: "Skill Up" },
  { branch: SORCERY, level: 72, reason: "CRIT +1" },
  { branch: SORCERY, level: 75, reason: "Skill Up" },
  { branch: SORCERY, level: 77, reason: "DODGE +10" },
  { branch: SORCERY, level: 80, reason: "Skill Up" },
  { branch: SORCERY, level: 82, reason: "DODGE +5" },
  { branch: SORCERY, level: 85, reason: "Skill Up" },

  { branch: SUSTENANCE, level: 2, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 5, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 10, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 12, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 15, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 20, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 22, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 25, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 30, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 35, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 37, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 40, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 45, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 47, reason: "MSPD +3, DODGE +5" },
  { branch: SUSTENANCE, level: 50, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 52, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 55, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 60, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 62, reason: "MSPD +3" },
  { branch: SUSTENANCE, level: 65, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 67, reason: "DODGE +5" },
  { branch: SUSTENANCE, level: 70, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 75, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 77, reason: "MSPD +2, DODGE +5" },
  { branch: SUSTENANCE, level: 80, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 85, reason: "Skill Up" },
  { branch: SUSTENANCE, level: 87, reason: "DODGE +5" },
  // ...MAX_OUT,
];

export const PvP = {
  "Skye's Build": SKYE_BUILD,
  "Focus Meta To Skills": FOCUS_META_WITH_SKILLS,
  "Focus Meta To Breakpoints": FOCUS_META_WITHOUT_SKILLS,
  "Focus Sustenance To Breakpoints, Then Well Rounded": FOCUS_ONE_FIRST_ROUNDED_AFTER,
  "Focus Sustenance, Celerity, Then Well Rounded": FOCUS_TWO_FIRST_ROUNDED_AFTER,
  "Focus All To 25, Then Focus Meta": FOCUS_SKILLS_FIRST,
  "Well Rounded To 25, Then Focus Meta": ROUNDED_SKILLS_FOCUS_AFTER,
  "Well Rounded To Breakpoints": WELL_ROUNDED,
  "Max Out Focus": MAX_OUT,
};

export const PvE = {
  "Talene Rosaline Twins Rowan Ezizh": TALENE_ROSA_TWINS_ROWAN_EZIZH,
  "Talene Rowan Ezizh Mehira Twins": TALENE_ROWAN_EZIZH_MEHIRA_TWINS,
  "Talene Rosaline Warek Rowan Twins": TALENE_ROSA_WAREK_ROWAN_TWINS,
  "Shemira Rowan Baden Rosaline Twins": SHEMIRA_ROWAN_BADEN_ROSA_TWINS,
  "Shemira Estrilda Rosaline Rowan Twins": SHEMIRA_ESTRILDA_ROSA_ROWAN_TWINS,
  "Belinda Rosaline Twins Rowan Lorsan": BELINDA_ROSA_TWINS_ROWAN_LORSAN,
};

export const AllBuilds = { ...PvP, ...PvE };
